import { motion } from 'framer-motion';
import { CalendarX, TrendingDown, UserX, ShieldAlert, Swords, HelpCircle } from 'lucide-react';

const cases = [
  { icon: CalendarX, title: 'Sales reps sitting idle', result: 'Empty calendars, and the phone isn\'t ringing.' },
  { icon: TrendingDown, title: 'Growth has stalled', result: 'Referrals alone won\'t take you to the next level.' },
  { icon: UserX, title: 'Bad lead quality', result: 'Tire-kickers and price shoppers wasting your reps\' time.' },
  { icon: ShieldAlert, title: 'Burned by past agencies', result: 'Big promises, shared leads, no kitchens sold.' },
  { icon: Swords, title: 'Losing to competitors online', result: 'Homeowners find them first and book with them.' },
  { icon: HelpCircle, title: 'No idea what marketing returns', result: 'No clear report tying spend to jobs.' },
];

export const ForYouIf = () => {
  return (
    <section className="section section-dark" id="for-you">
      <div className="container mx-auto max-w-6xl px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4"
        >
          Sound familiar?
        </motion.h2>
        <p className="text-muted-foreground text-center text-base md:text-lg mb-10 md:mb-14 max-w-2xl mx-auto">
          Built for kitchen remodeling companies doing $3M+ a year. One company per 30-mile radius.
        </p>
        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {cases.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 40, filter: 'blur(12px)' }}
              whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.15, ease: 'easeOut' }}
              className="glass-card"
            >
              <c.icon className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-bold mb-3">{c.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {c.result}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};